// extracted by mini-css-extract-plugin
export var body = "industry-module--body--16df8";
export var comingSoon = "industry-module--comingSoon--1550f";
export var deck = "industry-module--deck--cce93";
export var description = "industry-module--description--f1203";
export var featuredContent = "industry-module--featuredContent--0b139";
export var header = "industry-module--header--9c21d";
export var headerContainer = "industry-module--headerContainer--32972";
export var industrycareerdevelopment = "industry-module--industrycareerdevelopment--b841e";
export var intro = "industry-module--intro--ff557";
export var introWrap = "industry-module--introWrap--adba6";
export var jobsAtAGlance = "industry-module--jobsAtAGlance--962f7";
export var main = "industry-module--main--f8c2a";
export var mainArticle = "industry-module--mainArticle--915f7";
export var relatedContent = "industry-module--relatedContent--bece6";
export var root = "industry-module--root--53dbf";
export var subtitle = "industry-module--subtitle--d7c0c";
export var title = "industry-module--title--beabf";
export var video = "industry-module--video--85da9";